export default "__VITE_ASSET__BnbaUCwX__"